/* SiteCfUtility.js */

"use strict";

class SiteCFUtility {
    constructor() {
        this._inheritedCfs = [];
        this.inheritIconListener = this.inheritIconListener.bind(this);
        this._hierarchyObj = {};
        this.updateIconTitles = this.updateIconTitles.bind(this);
        this.onIconClick = this.onIconClick.bind(this);
    }
    /* customfield inheritance */
    getCustomFieldInheritance(currentEntity, parentEntity, cfDefs) {
        const cValues = currentEntity.customFieldValues;
        const cSources = currentEntity.customFieldSources;
        this._cfDefs = cfDefs;
        let pValues = [], pSources = [];
        if (parentEntity) {
            pValues = parentEntity.customFieldValues;
            pSources = parentEntity.customFieldSources;
        }
        if (!parentEntity) {
            return {};
        }
        let hierarchyObj = {};

        // List out inheritable customfields
        let inheritableCfs = [];
        inheritableCfs = Object.keys(this._cfDefs || {}).filter(
            (uuid) =>
                this._cfDefs[uuid].systemOwned !== true &&
                (this._cfDefs[uuid].deviceOnly !== undefined && this._cfDefs[uuid].deviceOnly !== true)
        );
        // check if they are inherited
        inheritableCfs.forEach(cf => {
            if (cSources[cf]) {
                hierarchyObj[cf] = {
                    sourceSite: cSources[cf].site,
                    defaultValue: cValues[cf],
                    isInherited: true,
                    val: cValues[cf],
                    updateToInheritance: "inherited"
                };
            } else {
                hierarchyObj[cf] = {
                    sourceSite: pSources[cf] ? pSources[cf].site : {
                        codeName: parentEntity.codeName,
                        id: parentEntity.id,
                        name: parentEntity.name
                    },
                    defaultValue: pValues[cf],
                    isInherited: false,
                    val: cValues[cf],
                    updateToInheritance: ""
                };
            }
        });
        this._hierarchyObj = hierarchyObj;
        return hierarchyObj;
    }

    updateCustomFieldsHierarchy(rootElem, entity, form) {
        const hierarchyObj = this._hierarchyObj;
        const cfHierarchyIconElList = [];
        const customFieldsEl = rootElem.querySelector(
            ".custom_field_values.rendered_control"
        ) || rootElem.querySelector(".custom_fields.rendered_control");
        const existingCfHierarchyEls = customFieldsEl ?
            customFieldsEl.querySelectorAll(".cf-hierarchy") :
            [];
        if (existingCfHierarchyEls && existingCfHierarchyEls.length > 0) {
            existingCfHierarchyEls.forEach(el => {
                el.remove();
            });
        }
        if (hierarchyObj && customFieldsEl) {
            Object.keys(hierarchyObj).forEach(cf => {
                const cfEl = customFieldsEl.querySelector("." + CSS.escape(cf.replaceAll("-", "_")));
                if (!cfEl) {
                    return;
                }
                const cfHierarchyEl = document.createElement("span");
                let titleText = "";
                cfHierarchyEl.classList.add("cf-hierarchy");
                const iconEl = document.createElement("base-icon-gl");
                iconEl.setAttribute("title", titleText);

                if (hierarchyObj[cf].isInherited) {
                    iconEl.title = "Override " + hierarchyObj[cf].sourceSite.name + " value";
                    iconEl.dataset.icon = "common.site_inheritnce_off";
                    iconEl.dataset.inherited = "yes";
                    cfEl.classList.add("disabled");
                }
                else {
                    iconEl.title = "Reset to " + hierarchyObj[cf].sourceSite.name + " value";
                    iconEl.dataset.icon = "common.site_inheritnce_on";
                    iconEl.dataset.inherited = "no";
                }

                cfHierarchyEl.appendChild(iconEl);
                cfHierarchyIconElList.push(iconEl);
                cfHierarchyEl.dataset.cfid = cf.replaceAll("-", "_");
                cfEl.after(cfHierarchyEl);
            });
        }
        this.registerInheritIconListeners(cfHierarchyIconElList, entity, form);
        return cfHierarchyIconElList;
    }

    updateIconTitles(rootElem) {
        const customFieldsEl = rootElem.querySelector(
            ".custom_field_values.rendered_control"
        ) || rootElem.querySelector(".custom_fields.rendered_control");
        const cfHierarchyEls = customFieldsEl.querySelectorAll(".cf-hierarchy");
        cfHierarchyEls.forEach(el => {
            const cfid = el.dataset.cfid;
            const iconEl = el.querySelector("base-icon-gl");
            if (el.dataset.inherited === "no") {
                iconEl.title = "Reset to " + this._hierarchyObj[cfid.replaceAll("_", "-")].sourceSite.name + " value";
            } else {
                iconEl.title = "Override " + this._hierarchyObj[cfid.replaceAll("_", "-")].sourceSite.name + " value";
            }
        });
    }

    registerInheritIconListeners(iconsList, entity, form) {
        iconsList.forEach(iconEl => {
            iconEl.addEventListener("click", (evt) => {
                this.onIconClick(evt, entity, form, iconEl);
            });
        });
    }

    onIconClick(evt, entity, form, iconEl) {
        const hierarchyObj = this._hierarchyObj;
        const updatedCustomFields = Object.assign(
            {},
            entity.getCustomFieldValues()
        );
        const rootEl = evt.target.closest(".custom_field_values") ||
            evt.target.closest(".custom_fields");
        const cfid = evt.target.closest(".cf-hierarchy").dataset.cfid;
        const cf = cfid.replaceAll("_", "-");
        const cfEl = rootEl.querySelector("." + CSS.escape(cfid));
        if (iconEl.dataset.inherited === "no") {
            iconEl.dataset.inherited = "yes";
            iconEl.dataset.icon = "common.site_inheritnce_off";
            cfEl.classList.add("disabled");
            hierarchyObj[cf]["updateToInheritance"] = "inherited";
            iconEl.title = "Override " + hierarchyObj[cf].sourceSite.name + " value";
            if (form) {
                let formVal = form.getValue();
                const cfGroup = formVal.customFields ? "customFields" : "customFieldValues";
                if (formVal[cfGroup]) {
                    formVal[cfGroup][cf] = hierarchyObj[cf].defaultValue;
                    form.setPristineValue(formVal);
                }
            }

        } else {
            iconEl.dataset.inherited = "no";
            cfEl.classList.remove("disabled");
            iconEl.dataset.icon = "common.site_inheritnce_on";
            hierarchyObj[cf]["updateToInheritance"] = "";
            updatedCustomFields[cf] = hierarchyObj[cf].defaultValue;
            iconEl.title = "Reset to " + hierarchyObj[cf].sourceSite.name + " value";
        }
        Object.keys(updatedCustomFields).forEach(key => {
            if (hierarchyObj[key] && hierarchyObj[key]["updateToInheritance"] === "inherited") {
                delete updatedCustomFields[key];
            }
        });
        entity.setDirectlyAssignedCustomFieldValues(updatedCustomFields);
    }

    generateInheritanceIconsME(rootElem, cfIds) {
        const cfHierarchyIconElList = [];
        const customFieldsEl = rootElem.querySelector(
            ".custom_field_values.rendered_control"
        ) || rootElem.querySelector(".custom_fields.rendered_control");
        cfIds.forEach(cf => {
            const cfEl = customFieldsEl.querySelector("." + CSS.escape(cf.replaceAll("-", "_")));
            if(!cfEl) {
                return;
            }
            const cfHierarchyEl = document.createElement("span");
            let titleText = "";

            cfHierarchyEl.classList.add("cf-hierarchy");
            const iconEl = document.createElement("base-icon-gl");
            iconEl.setAttribute("title", titleText);

            iconEl.dataset.icon = "siteexplorer.site";
            iconEl.dataset.inherited = "no";


            cfHierarchyEl.appendChild(iconEl);
            cfHierarchyIconElList.push(iconEl);
            cfHierarchyEl.dataset.cfid = cf.replaceAll("-", "_");
            cfEl.appendChild(cfHierarchyEl);
        });
        return cfHierarchyIconElList;
    }

    removeInheritIconListenersME(iconEls) {
        iconEls.forEach(iconEl => {
            iconEl.removeEventListener("click", this.inheritIconListener);
            iconEl.setAttribute("title", "");
        })
    }

    addInheritIconListenerME(iconEl) {
        iconEl.addEventListener("click", this.inheritIconListener);
        iconEl.setAttribute("title", "Reset to site value");
    }

    inheritIconListener(evt) {
    // debugger;
    // const rootEl = evt.target.closest(".custom_fields");
        const cfid = evt.currentTarget.closest(".cf-hierarchy").dataset.cfid;
        const cf = cfid.replaceAll("_", "-");
        // const cfEl = rootEl.querySelector("." + CSS.escape(cfid));
        const cfEl = evt.currentTarget.closest("." + CSS.escape(cfid));
        // const multiEditControl = cfEl.querySelector("input-powerbutton-control");
        // if(multiEditControl.classList.contains("checked")) {

        // }
        let inpEl;
        if(cfEl.classList.contains("text")) {
            inpEl = cfEl.querySelector("input-text-control");
        } else if (cfEl.classList.contains("number")) {
            inpEl = cfEl.querySelector("input-number-control");
        } else if (cfEl.classList.contains("boolean")) {
            inpEl = cfEl.querySelector("input-checkbox-control");
        } else if (cfEl.classList.contains("enum")) {
            inpEl = cfEl.querySelector("gl-multi-select");
        }
        if (evt.currentTarget.dataset.icon === "common.site_inheritnce_off") {
            evt.currentTarget.dataset.icon = "common.site_inheritnce_on";
            evt.currentTarget.setAttribute("title", "Reset to site value");
            inpEl.classList.remove("disabled");
            if (this._inheritedCfs.indexOf(cf) >= 0) {
                this._inheritedCfs.splice(this._inheritedCfs.indexOf(cf), 1);
            }
        } else {
            evt.currentTarget.dataset.icon = "common.site_inheritnce_off";
            evt.currentTarget.setAttribute("title", "Override site value");
            inpEl.classList.add("disabled");
            this._inheritedCfs.push(cf);
        }

        // console.log(this._inheritedCfs);
    }

    getInheritedCfs() {
        return this._inheritedCfs;
    }
    clearInheritedCfs() {
        this._inheritedCfs = [];
    }
}

module.exports = SiteCFUtility;